import { Message, MessageBox } from 'element-ui'
import { i18n } from '@/i18n'

export const handleErrorMessage = (
  error: any,
  defaultMessage?: string,
  rethrowError?: boolean,
): void => {
  let message = defaultMessage ?? 'Произошла ошибка!'

  if (error instanceof Error) {
    message = (error as any).response?.data?.message ?? error.message
  } else if (typeof error === 'string') {
    message = error
  }

  Message.error(message)

  if (rethrowError ?? true) throw error
}

export const showErrorMessage = (
  message: string,
  options?: {
    duration?: number
  },
) => {
  Message({
    message,
    type: 'error',
    duration: options?.duration ?? 3000,
  })
}

export const showSuccessMessage = (message: string) => {
  Message.success(message)
}

export const confirmWarning = async (
  message: string,
  options?: {
    confirmText?: string
    cancelText?: string
  },
): Promise<boolean> => {
  try {
    await MessageBox.confirm(message, i18n.t('toast.warning').toString(), {
      confirmButtonText: options?.confirmText ?? i18n.t('toast.yes').toString(),
      cancelButtonText: options?.cancelText ?? i18n.t('toast.cancel').toString(),
      type: 'warning',
    })
    return true
  } catch (err) {
    return false
  }
}
